import styled from 'styled-components';
import { ViewAllExperiencesButton } from 'components/molecules/NotFoundExperienceMessage/NotFoundExperienceMessage.styled';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 48px 24px 24px 24px;
  font-family: ${({ theme }) => theme.font.primaryFont};
`;

// The same button as the plain not-found screen, so the two screens match.
export const ExploreAllButton = styled(ViewAllExperiencesButton)`
  && {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
